import { useSyncExternalStore } from 'react';

/**
 * Modern layout: the bet slip opens as a sheet over the page instead of
 * going to /bet-slip. The modern footer shows it; anything may open it.
 */
let open = false;
const listeners = new Set<() => void>();

const set = (next: boolean) => {
  if (open === next) return;
  open = next;
  listeners.forEach((l) => l());
};

export const openSlipSheet = () => set(true);
export const closeSlipSheet = () => set(false);

export const useSlipSheetOpen = () =>
  useSyncExternalStore(
    (l) => {
      listeners.add(l);
      return () => listeners.delete(l);
    },
    () => open
  );
